import axiosInstance, { handleLogout } from './axiosInstance';

export async function getSession(id, platform) {
    try {
        const requestUrl = `/session/?id=${id}&platform=${platform}`;
        const response = await axiosInstance.get(requestUrl, {
            headers: {
                Authorization: `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`,
            },
        });
        
        const resonseData = await response.data;
        return resonseData;
    } catch (error) {
        console.log(error);
        return error;
    }
}

export async function fetch_all_sessions_of_one_model(modelID, userToken, companyID, platform) {
    try {
        // Step 2: Fetch the session data from the API
        const requestUrl = `/session/?modelID=${modelID}&action=getSessions&platform=${platform}`;
        const response = await axiosInstance.get(requestUrl, {
            headers: {
                Authorization: `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`,
            },
        });

        // Parse the response JSON
        const responseData = response.data;
        return responseData;
    } catch (error) {
        console.log(error);
        return error;
    }
}

export async function lockSession(id, lock, system, userToken, platform) {
    try {
        const requestObj = { id: id, platform: platform, action: lock ? "lock" : "unlock", system: system, onSessionToken: userToken };
        const requestUrl = `/session/`;

        const response = await fetch(requestUrl, {
            method: "PATCH", 
            headers: {
                Authorization: `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`
            },
            body: JSON.stringify(requestObj)
        });
        
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error updating data:', error);
        throw error;
    }
}

export async function getModelProxy(modelID) {
    try {
        const requestUrl = `/session/?proxy=1&modelID=${modelID}`;
        const response = await axiosInstance.get(requestUrl, {
            headers: {
                Authorization: `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`,
            },
        });
        const responseData = await response.json();
        return responseData.proxy ?? null;
    } catch (error) {
        console.log(error);
        return error;
    }
}

export async function createSession(sessionObj) {
    try {
        const requestUrl = `/session/`;
        const response = await axiosInstance.post(requestUrl, {
            headers: {
                Authorization: `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`,
            },
            body: JSON.stringify(sessionObj),
        });
        const resonseData = await response.json();
        // console.log(">>>>RESPONSE<<<<", resonseData);
        return resonseData;
    } catch (error) {
        console.log(error);
        return error;
    }
}

export async function updateSession(sessionObj) {
    console.log("updating session");
    try {
        const requestUrl = `/session/`;
        const requestObject = {
            id: parseInt(sessionObj.id),
            cookies: sessionObj.cookies,
            onSession: parseInt(user.userID),
            // eslint-disable-next-line camelcase
            local_storage: sessionObj.local_storage,
            // eslint-disable-next-line camelcase
            user_agent: sessionObj.user_agent,
        };
        const response = await axiosInstance.patch(requestUrl, {
            headers: {
                Authorization: `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`,
            },
            body: JSON.stringify(requestObject),
        });
        const resonseData = await response.json();
        return resonseData;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export async function deleteSession(id) {
    try {
        const requestUrl = `/session/?id=${id}`;
        const response = await axiosInstance.delete(requestUrl, {
            headers: {
                Authorization: `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`,
            },
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.log(error);
        return error;
    }
}